module.exports = __webpack_public_path__ + "static/media/lora1 (2).b4d6a1f4.jpg";